import { useEffect, useState } from 'react';
import config from '../config';

export default function useTag() {
  const [tag, setTag] = useState('');

  useEffect(() => {
    fetch(config.apiURL + '/current_version')
      .then((res) => res.json())
      .then((data) => setTag(data));
    // setTag('v0.7.8');
  }, []);

  return tag;
}
